import React from "react";
// import logo from './logo.svg';
import "./App.css";
import PhotoEditor from "./components/PhotoEditor/PhotoEditor";

function App() {
  return (
    <div className="App">
      <PhotoEditor />
    </div>
  );
}

export default App;
